export const homePageConstants = {
    GETDETAILS_REQUEST: 'GET_DETAILS_REQUEST',
    GETDETAILS_SUCCESS: 'GET_DETAILS_SUCCESS',
    GETDETAILS_FAILURE: 'GET_DETAILS_FAILURE',
    GETLICENCEDOC_REQUEST: 'GET_LICENCE_DOC_REQUEST',
    GETLICENCEDOC_SUCCESS: 'GET_LICENCE_DOC_SUCCESS',
    GETLICENCEDOC_FAILURE: 'GET_LICENCE_DOC_FAILURE'
 }